import React, {Component, createRef} from "react";

// Styles
import "./Welcome.scss";

// Components
import Header from "components/Header";
import GameScreen from "../../components/GameScreen";
import PlayIcon from 'static/img/playicons.svg';
import Run from 'static/img/RUN.svg';
import AntiRotate from 'static/img/antirotate.svg';
import Rotate from 'static/img/rotate.svg';
import RightBot from 'static/img/right-bot.svg';
import Astronaut from 'static/img/astronaut.svg';
import Button from "components/Button";
import PlayImage from 'static/img/playimg.svg';
import SkullTile from 'static/icons/skip-tile.svg';


// Images
// Constants
import {createLevelMap, levelsMap} from "../../utility/levelsData";
import UpArrow from "../../static/img/upperDirection.svg";
import RotateClockwiseIcon from "../../static/img/rotate2icon.svg";
import RotateAntiClockwiseIcon from "../../static/img/antirotate3icon.svg";
import Downwards from "../../static/img/downwards.svg";
import Smash from "../../static/img/smash.svg";
import CircularRedCloseIcon from "../../static/icons/circular-red-close-icon.svg";
import DashedCircle from "../../static/img/dashed-circle.svg";
import { GAME_TIME } from "utility/Timer";
import { storage } from "services/config/storage";

class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTutorialPage: 1,
            maxTutorialPages: 9,
            isMobileView: false,
            mainMethodTilesArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            currentLevelMap: createLevelMap({
                matrix:{ row: 7, col: 6 },
                player: { x: 2, y: 0 },
                lights: 1,
                facing: "UP",
                optimal: 5,
                procedure: false,
                tileMap: [
                    [4, 4, 4, 4],
                    [4, 0, 0, 4],
                    [4, 0, 0, 4],
                    [4, 0, 0, 2]
                ]
            }),
            showSkipButton: false,
        };
        this.gameRef = createRef();
        this.gameDetails = storage.get.gameDetails();
    }

    componentDidMount() {
        if (localStorage.getItem("is_reloaded")) {
            localStorage.removeItem("is_reloaded");
            // this.props.history.push("/");
        } else {
            localStorage.setItem("is_reloaded", true);
        }
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        window.addEventListener("resize", () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });

        document.querySelector("body").style.overflow = "hidden";
    }

    componentWillUnmount() {
        clearInterval(this.gameTimer);
        document.querySelector("body").style.overflow = "auto";
    }

    getResponsiveMainCardContent = () => {
        const {
            mainMoves = []
        } = this.state

        return (
            <>
                <div className="main-card__content--moves">
                    {mainMoves.map((move, index) => {
                        return (
                            <div className={`move-icon`} key={index}>
                                <img src={DashedCircle} alt="Dashed circular icon"/>
                            </div>
                        )
                    })}
                </div>
                {mainMoves.length > 0
                &&
                <img
                    src={CircularRedCloseIcon}
                    alt="Close icon"
                    className="main-card__content--clear-icon"
                />
                }
            </>
        )
    }
    getMainCardContent = () => {
        return (
            <div className="main-card__content--moves">
                {this.state.mainMethodTilesArray.map((value, index) => index).map(item => {
                    return (
                        <div className={'move-icon dashed-circle'} key={item}>
                            <img src={DashedCircle} alt="Dashed circular icon"/>
                        </div>
                    )
                })}
            </div>
        )
    }

    startGameplay = () => {
        return this.props.history.replace({pathname:'/level',level:1,subLevel:1});
    }

    moveToNextTutorial() {
        if (this.state.currentTutorialPage >= this.state.maxTutorialPages) {
            if (this.props.onComplete) return this.props.onComplete();
            return this.startGameplay();
        }
        this.setState((prevState) => {
            return {
                ...prevState,
                currentTutorialPage: prevState.currentTutorialPage + 1
            };
        })
    }
    getMessageDisplayBox(){
        switch (this.state.currentTutorialPage){
            case 1: return(
                <div className="first-command">
                    <p className="welcome-screen-command">Welcome to <span
                        style={{color: '#24A2F6'}}>{this.gameDetails?.gameName || 'BotBerry'}</span></p>
                    <p className="bottom-text">Click anywhere to continue</p>
                </div>
            )
            case 2: return(
                <div>
                  <div className="tile-table">
                      {/* <tr> */}
                          <div className="empty silver-tile">      
                            <div class="lit-child"></div><img src={RightBot} alt="player" class="right-bot-character"></img>
                          </div>
                          <div className="empty silver-tile"></div>
                          <div className="empty silver-tile power-tile"></div>
                      {/* </tr> */}
                  </div>
                <div className="first-command next-command">
                    <p className="welcome-screen-command welcome-text2">I need your help to guide <p style={{display:'block'}}>me to the<span
                        style={{color: '#7AE73F'}}> power tiles.</span>
                        </p>
                        </p>
                </div>
                </div>
            )
            case 3: return(
                <div className="first-command next-command">
                    <div style={{display:'flex' , flexWrap:'wrap'}}>
                       <p className="welcome-screen-command welcome-text2">
                        The <img className="directionImg"src={UpArrow} alt="direction" />command tells me  <p style={{display:'block'}}>to <span style={{color: '#24A2F6'}}>walk forward.</span></p> </p>
                        </div>
                </div>
            )
            case 4: return(
                <div className="first-command next-command">
                     <div style={{display:'flex' , flexWrap:'wrap'}}>
                       <p className="welcome-screen-command welcome-text2">
                        The <img className="directionImg" src={Smash}  alt="Light icon" />command tells me  <p style={{display:'block'}}>to <span style={{color: '#78E43E'}}> light up the power tile.</span></p> </p>
                    </div>
                </div>
            );
            case 5: return(
                <div className="first-command next-command">
                  <p className="welcome-screen-command welcome-text2">
                    The  <img  className="directionImg" src={RotateAntiClockwiseIcon} alt="Clockwise rotation icon"/> command tells me   <p style={{display:'block'}}>to <span style={{color: '#ffc414'}}> rotate left.</span></p> </p>
                </div>
            );
            case 6: return(
                <div className="first-command next-command">
                <p className="welcome-screen-command welcome-text2">
                  The  <img  className="directionImg" src={RotateClockwiseIcon} alt="Anti Clockwise rotation icon"/> command tells me  <p style={{display:'block'}}>to <span style={{color: '#d24eff'}}> rotate right.</span></p> </p>
              </div>
            )
            case 7: return(
                <div className="first-command">
                <p className="welcome-screen-command welcome-text2">
                  The  <img  className="directionImg" src={Downwards} alt="Jump icon"/> command tells me  <p style={{display:'block'}}>to <span style={{color: '#ff7a2d'}}> jump over <img src={SkullTile} alt="danger" className="skullimage" /> tile.</span> </p></p>
                </div>
            )
            case 8: return(
                <div className="first-command commandLoading">
                <p className="welcome-screen-command welcome-text2">
                Load commands from the<p style={{display:'block'}}> command tray .</p></p>
                </div>
            )
            case 9: return(
                // <div className="first-command commandLoading">
                //     <p className="welcome-screen-command welcome-text2">Click to test your solution. Good luck!</p>
                // </div>
                <div className="first-command last-step">
                <p className="welcome-screen-command welcome-text2">
                  Click <img className="playImage" src={PlayImage} alt="Playimage"/>to test your <p style={{display:'block'}}>solution. Good luck!</p>
                  <p className="bottom-text">Click anywhere to start the game.</p>
                  </p>
                </div>

            )
            default:
                return "";
        }
    }
    getFunctionButtons(){
        const buttons = [
            {src:UpArrow,alt:"ForwardIcon"},
            {src:RotateClockwiseIcon,alt:"Clockwise rotation icon"},
            {src:RotateAntiClockwiseIcon,alt:"Anti Clockwise rotation icon"},
            {src:Downwards,alt:"Jump icon"},
            {src:Smash,alt:"Light icon"},
        ];
        return buttons.map((el,elIndex)=> (
            <Button key={elIndex}
                className="btn btn__square--md btn__image margin">
                <img src={el.src} alt={el.alt}/>
            </Button>
        ))
    }
    render() {
        const { seconds=GAME_TIME } = this.props;
        return (
            <>
                <div className="lavel-start" onClick={() => this.moveToNextTutorial()}>
                    <div className="level-layout first-tutorial">
                        <Header
                            seconds={seconds}
                            isTutorial={true}
                        />
                        <div className="main-container">
                            <div className="level-container">
                                <GameScreen
                                    ref={this.gameRef}
                                    metaData={this.state.currentLevelMap.metadata}
                                    data={this.state.currentLevelMap.data}
                                />
                            </div>
                            <div className="options-container">
                                <div className="play-container">
                                    <Button className = {this.state.currentTutorialPage  < 9 ? 'play-btn' : 'play-btn play-btn2'}>
                                        <img src={PlayIcon} alt="Play icon" className="play-icon"/>
                                        <img src={Run} alt="Play icon" className="play-text"/>
                                    </Button>
                                    <div>
                                        <button className="rotate" style={{marginRight: "16px"}}>
                                            <img src={Rotate} alt="Play icon" className="rotate-icon"/>
                                        </button>
                                        <button className="rotate">
                                            <img src={AntiRotate} alt="Play icon" className="rotate-icon"/>
                                        </button>
                                    </div>
                                </div>
                                <div className="options-component">
                                    <div className="main-card without-bordered without-bordered2">
                                       
                                        {/* {this.state.currentTutorialPage === 4 ?
                                            <button className="direction">
                                                <img
                                                    src={SmashLight}
                                                    alt="Light icon"
                                                />
                                            </button>
                                            : ""} */}
                                        {/* {this.state.currentTutorialPage === 5 ?

                                            <button className="direction">
                                                <img
                                                    src={RotateIcon}
                                                    alt="Clockwise rotation icon"
                                                />
                                            </button>
                                            : ""} */}
                                        {/* {this.state.currentTutorialPage === 6 ?

                                            <button className="direction">
                                                <img src={RightRotate} alt="Anti Clockwise rotation icon"/>
                                            </button>
                                            : ""} */}
                                        {/* {this.state.currentTutorialPage === 7 ?
                                            <button className="direction">
                                                <img src={UpperDirection} alt="Jump icon"/>
                                            </button> : ""} */}


                                        <div className="main-card__title" style={{opacity:'.2'}}>
                                            <p className="main-card__title--text" style={{opacity:'.2'}}>
                                                Main
                                            </p>
                                        </div>
                                        <div className="main-card__content">
                                            {this.isMobileView
                                                ?
                                                this.getResponsiveMainCardContent()
                                                :
                                                this.getMainCardContent()
                                            }
                                        </div>
                                    </div>
                                    <div className = {this.state.currentTutorialPage  === 8 ? 'command' : '' }>
                                    <div className = {this.state.currentTutorialPage === 8 ?  'move-card main-card highOpacity' : 'move-card main-card' }>
                                        <div className="move-card__title">
                                            <p className="move-card__title--text">
                                                Commands
                                            </p>
                                        </div>
                                        <div className="move-card__content">
                                            <div className="move-card__content--left-container">
                                                {this.getFunctionButtons()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="welcome-wrapper">
                            <div className="command-section">
                                <div className= {this.state.currentTutorialPage < 8 ? 'flex-tab' : this.state.currentTutorialPage === 8 ? 'flex-tab2' : 'GoodLuckScreen'}>
                                {/* <img src={this.state.currentTutorialPage < 7 ? Astronaut: MiddleBot} alt="astronaut" className="bot"/> */}
                                  <img src={Astronaut} alt="astronaut" className="bot"/>
                                {this.getMessageDisplayBox()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Welcome;
